<template>
	<div class="wrapper">
		<div class="murk">
			<BalanceInfo :title="region === 'global' ? $t('checkout.buy-nx') : $t('add-balance')" show-switch-account />

			<div class="success-purchase">
				<div class="success-purchase__title">
					{{ $t('checkout.purchase-complete') }}
					<template v-if="region === 'th' && selectedAmount && amount && amount !== selectedAmount">
						<div class="success-purchase__title__info">
							{{
								$t('checkout.purchase-success-subtitle', {
									amount: $n(amount, 'currency', balanceCurrency),
								})
							}}
						</div>
						<div class="success-purchase__title__description">
							{{
								$t('checkout.purchase-success-description', {
									amount: $n(amount, 'currency', balanceCurrency),
								})
							}}
						</div>
					</template>
				</div>
				<div class="success-purchase__order">
					<div class="success-purchase__order__row">
						<span>{{ $t('checkout.order-number') }}</span>
						<span>{{ orderNumber }}</span>
					</div>
					<div class="success-purchase__order__row">
						<span>{{ $t('checkout.order-date') }}</span>
						<span>{{ orderDate }}</span>
					</div>
					<div class="success-purchase__order__row">
						<span>{{ $t('checkout.payment-method') }}</span>
						<span>{{ paymentMethod }}</span>
					</div>
				</div>
				<div class="success-purchase__order-detail">
					<div class="success-purchase__order-detail__title">
						{{ $t('checkout.order-details') }}
					</div>
					<div v-for="(product, index) in products" :key="index" class="order-item">
						<div class="order-item__qty">
							<span>{{ $t('checkout.qty') }}</span>
							<span>{{ product.quantity }}</span>
						</div>
						<div class="order-item__type">
							<span>{{ $t('item') }}</span>
							<currency
								v-if="
									product.productType &&
										(product.productType === 'nxwallet' || product.productType === 'wallet')
								"
								:code="balanceCurrency"
								:value="product.value"
							/>
							<span v-else>
								{{ product.name }}
							</span>
						</div>
						<div class="order-item__total">
							<span>{{ $t('checkout.total') }}</span>
							<span>{{ $n(product.amount, 'currency', product.currency) }}</span>
						</div>
					</div>
					<div class="order-price">
						<!-- <div class="order-price__row">
							<span>{{ $t('checkout.discount') }}</span>
							<span>-</span>
						</div> -->
						<div v-if="hasSalesTax" class="order-price__row">
							<span>{{ $t('checkout.sales-tax') }}</span>
							<span>{{ $n(taxAmount, 'currency', paymentInfoCurrenty) }}</span>
						</div>
						<div class="order-price__row">
							<span>{{ $t('checkout.price') }}</span>
							<span>{{ $n(subTotalAmount, 'currency', paymentInfoCurrenty) }}</span>
						</div>
						<div class="order-price__total">
							<span>{{ $t('checkout.total-amount') }}</span>
							<span>{{ $n(totalAmount, 'currency', paymentInfoCurrenty) }}</span>
						</div>
					</div>
				</div>
				<div class="current-balance">
					<span class="current-balance__title">
						{{ $t('checkout.current-balance-is') }}
					</span>
					<div class="amount-container">
						<div class="amount">
							<currency class="amount__value" :code="balanceCurrency" :value="totalBalanceAmount" />
						</div>
					</div>
				</div>
				<div class="success-purchase__action">
					<FormButton class="btn-primary" :label="setButtonText" :button-click="buttonAction"></FormButton>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BalanceInfo from '@/components/common/balance-info';
import { FormButton } from '@arena/toolkit';
import config from '@/config/environment-config';
import currency from '../../common/currency';

export default {
	name: 'PurchaseCompleted',
	components: {
		BalanceInfo,
		FormButton,
		currency,
	},
	props: {
		orderNumber: {
			type: String,
			default: '',
		},
		orderDate: {
			type: String,
			default: '',
		},
		paymentInfo: {
			type: Object,
			default: () => ({
				currency: '',
				displayName: '',
				hasSalesTax: false,
				methodType: '',
				subTotalAmount: 0,
				taxAmount: 0,
				totalAmount: 0,
			}),
		},
		productPurchaseInfo: {
			type: Object,
			default: () => ({
				products: [],
			}),
		},
		returnURL: {
			type: String,
			default: null,
		},
	},
	data() {
		return {};
	},
	computed: {
		appType() {
			return this.$store.state.appType;
		},
		paymentMethod() {
			return this.paymentInfo.displayName;
		},
		products() {
			return this.productPurchaseInfo.products;
		},
		paymentInfoCurrenty() {
			return this.paymentInfo.currency;
		},
		subTotalAmount() {
			return this.paymentInfo.subTotalAmount;
		},
		hasSalesTax() {
			return this.paymentInfo.hasSalesTax;
		},
		taxAmount() {
			return this.paymentInfo.taxAmount;
		},
		totalAmount() {
			return this.paymentInfo.totalAmount;
		},
		balanceCurrency() {
			return this.$store.state.accountBalance.currency;
		},
		totalBalanceAmount() {
			return this.$store.state.accountBalance.total;
		},
		amount() {
			return this.productPurchaseInfo.amount;
		},
		selectedAmount() {
			return this.productPurchaseInfo.selectedAmount;
		},
		setButtonText() {
			if (this.appType === 'game') {
				return this.$t('checkout.close-window');
			}
			return this.$t('checkout.make-another-transaction');
		},
	},
	mounted() {
		this.$a2s.view('purchase_completed_imp', {
			name: 'Payment_Method',
			value: this.paymentMethod,
		});
	},
	methods: {
		buttonAction() {
			this.$a2s.click('purchase_completed_done');

			if (this.appType === 'game') {
				window.close();
			} else if (this.returnURL) {
				this.goto(this.returnURL);
			} else {
				window.location.href = `${config[process.env.VUE_APP_ENV][environment.region].wallet}/${
					this.$i18n.locale
				}/add-balance`;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.success-purchase {
	display: flex;
	flex-wrap: wrap;
	max-width: 640px;
	margin-top: 50px;
	margin-left: auto;
	margin-right: auto;
	&__title {
		flex: 0 0 100%;
		max-width: 100%;
		font-size: 24px;
		color: #fff;
		text-align: center;
		line-height: 1;
		padding-bottom: 34px;
		border-bottom: 2px solid rgba(#fff, 50%);
		&:before {
			content: '';
			display: block;
			width: 100%;
			height: 100px;
			background-image: url('~@/images/purchase-complete.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
			margin-bottom: 9px;
		}
		&__info {
			font-size: 18px;
			margin-top: 10px;
			margin-bottom: 11px;
		}
		&__description {
			color: rgba(#fff, 0.5);
			font-size: 14px;
			line-height: 1.3;
			padding-left: 30px;
			padding-right: 30px;
			margin-bottom: 2px;
		}
	}
	&__order {
		padding-top: 2px;
		padding-bottom: 7px;
		&__row {
			padding-top: 15px;
			> span {
				display: block;
				&:last-child {
					padding-top: 8px;
					color: #fff;
				}
			}
		}
	}
	&__order-detail {
		flex: 0 0 100%;
		max-width: 100%;
		&__title {
			padding-top: 28px;
			padding-bottom: 8px;
			margin-bottom: 17px;
			border-bottom: 1px solid rgba(#fff, 20%);
		}
		.order-item {
			display: flex;
			flex-wrap: wrap;
			&__qty,
			&__type,
			&__total {
				@media (max-width: 1023px) {
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;
					flex: 0 0 100%;
					max-width: 100%;
					padding-bottom: 17px;
				}
				> span {
					&:last-child {
						color: #fff;
					}
				}
			}
			&__total {
				flex-basis: auto;
				flex-grow: 1;
				max-width: 100%;
				margin-left: auto;
				text-align: right;
			}
		}

		.order-price {
			display: flex;
			flex-wrap: wrap;
			padding-top: 20px;
			&__row,
			&__total {
				display: flex;
				flex-wrap: wrap;
				flex: 0 0 100%;
				max-width: 100%;
				justify-content: space-between;
				> span {
					&:last-child {
						color: #fff;
					}
				}
			}
			&__row {
				padding-top: 18px;
			}
			&__total {
				border-top: 1px solid rgba(#fff, 20%);
				margin-top: 18px;
				padding-top: 17px;
				font-weight: bold;
				color: #fff;
				font-size: 24px;
			}
		}
	}
	.current-balance {
		display: flex;
		flex-wrap: wrap;
		flex: 0 0 100%;
		max-width: 100%;
		background-color: rgba(#000, 50%);
		justify-content: center;
		align-items: flex-end;
		padding-bottom: 18px;
		padding-left: 15px;
		padding-right: 15px;
		margin-top: 41px;
		&__title {
			padding-top: 17px;
		}
		.nx-amount-container,
		.amount-container {
			display: inline-flex;
			flex-wrap: wrap;
			justify-content: center;
			.nx-amount,
			.amount {
				padding-left: 10px;
				padding-top: 14px;
				&__type {
					color: #fff;
				}
				&__value {
					color: #eda03b;
					font-weight: bold;
				}
			}
			.nx-amount {
				&__value {
					padding-left: 5px;
				}
			}
		}
	}
	&__action {
		display: flex;
		flex-wrap: wrap;
		flex: 0 0 100%;
		max-width: 100%;
		justify-content: center;
		button {
			min-width: 320px;
			width: auto;
			margin-top: 40px;
		}
	}
}

@media (max-width: 599px) {
	.success-purchase {
		margin-top: 20px;
		&__title {
			padding-bottom: 16px;
		}
		.order-price {
			&__total {
				font-size: 16px;
			}
		}
		&__action {
			button {
				max-width: 100%;
				min-width: 320px;
				width: 100%;
			}
		}
	}
}

@media (min-width: 1024px) {
	.success-purchase {
		&__order {
			display: table;
			padding-bottom: 0;
			&__row {
				display: table-row;
				> span {
					display: table-cell;
					padding-top: 14px;
					&:first-child {
						padding-right: 28px;
					}
				}
			}
		}

		&__order-detail {
			display: flex;
			flex-wrap: wrap;
			&__title {
				flex: 0 0 100%;
				max-width: 100%;
				padding-bottom: 18px;
			}
			.order-item {
				flex: 0 0 100%;
				max-width: 100%;
				&__qty,
				&__type,
				&__total {
					display: flex;
					flex-direction: column;
					> span {
						&:last-child {
							padding-top: 16px;
						}
					}
				}
				&__qty {
					padding-right: 29px;
				}
				&__type {
					padding-right: 29px;
				}
				&__total {
					flex-basis: auto;
					flex-grow: 1;
					max-width: 100%;
					text-align: right;
				}
			}
		}
		.order-price {
			display: block;
			min-width: 50%;
			margin-left: auto;
			padding-top: 27px;
			line-height: 1.5;
			&__row {
				padding-top: 6px;
			}
			&__total {
				padding-top: 6px;
				margin-top: 13px;
				span {
					&:last-child {
						padding-left: 25px;
					}
				}
			}
		}
	}
}
</style>
